export default __webpack_public_path__ + "static/media/@leilabettcher.bb423784.jpg";